const weekDaysMap = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
};

const weekdaysName = Object.keys(weekDaysMap);
const weekdaysNum = Object.values(weekDaysMap);
const d = new Date();
const today = d.getDay();

export function setTimesCurrentDay(schedule = []) {
  const dayNums = getDayNums(schedule);

  // set times to current day
  if (dayNums.includes(today)) {
    const dayName = weekdaysName[today];
    const startTime = getDayTime(schedule, dayName, 'startTime');
    const endTime = getDayTime(schedule, dayName, 'endTime');

    return {
      startTime: formatTime(startTime[0]),
      endTime: formatTime(endTime[0]),
    };
  }

  // set times to next available day
  if (!dayNums.includes(today)) {
    const same = weekdaysNum.filter((num) => dayNums.includes(num));
    let firstAvailable;

    for (let i = 0; i < same.length; i++) {
      if (today < same[i]) {
        firstAvailable = same[i];
        break;
      }
    }

    const dayName = weekdaysName[firstAvailable];
    const startTime = getDayTime(schedule, dayName, 'startTime');
    const endTime = getDayTime(schedule, dayName, 'endTime');

    return {
      startTime: formatTime(startTime[0]),
      endTime: formatTime(endTime[0]),
    };
  }
}

export function formatTime(time) {
  const t = parseFloat(time) / 100;
  const rdDown = Math.floor(t);
  const sub = parseFloat((t - Math.floor(t)).toFixed(2));

  return rdDown + (sub * 100) / 60;
}

export function formatDate(weekday, year, month, day) {
  const selectedDate = new Date(year, month - 1, day);
  const monthName = new Date(year, month - 1, day).toLocaleDateString('en-US', { month: 'long' });

  return `${weekday.get(selectedDate.getDay())}, ${monthName} ${day}`;
}

export function getDayNums(schedule = []) {
  const available = schedule.map((a) => a.day);

  return available.reduce((accum, day) => {
    if (weekDaysMap.hasOwnProperty(day)) {
      accum.push(weekDaysMap[day]);
    }
    return accum;
  }, []);
}

export function getDayTime(schedule, dayName, time) {
  return schedule.filter((a) => a.day === dayName).map((t) => t[time]);
}

const UTC = 'Z';
export const asMMDDYYYY = (utcTime: string) =>
  new Date(`${utcTime}${UTC}`).toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
export const isBusinessHours = (): boolean => {
  const now = new Date();

  // Get the current time in Eastern Time
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/New_York',
    weekday: 'short',
    hour: 'numeric',
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const formattedParts = formatter.formatToParts(now);

  // Extract the day of the week and hour
  const dayOfWeek = formattedParts.find((part) => part.type === 'weekday')?.value;
  const hour = parseInt(formattedParts.find((part) => part.type === 'hour')?.value || '0', 10);

  // Define business hours
  const isWeekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].includes(dayOfWeek || '');
  const isSunday = dayOfWeek === 'Sun';

  if ((isWeekday && hour >= 9 && hour < 21) || (isSunday && hour >= 9 && hour < 18)) {
    return true;
  }

  return false;
};

export const toISOStringOrNull = (datetime: string) => {
  const parsedDateTime = new Date(datetime);
  return isNaN(parsedDateTime.getTime()) ? null : parsedDateTime.toISOString();
};
